import { Button, Card, Col, Flex, Row, Typography } from 'antd';

import { ImageGallery } from '@app/components';
import { TextFileComponent } from '@app/components/Chat/components';
import { textExtensions } from '@app/components/Chat/constants';
import { PREFIX } from '@app/constants';
import { type NActionsHistory } from '@app/types';
import { getFileImage } from '@app/utils';

import {
  useViewSendout,
  useViewSendoutsEffects,
} from '@pages/Sendouts/ViewSendouts/hooks';
import '@pages/Sendouts/ViewSendouts/styles/ViewSendouts.desktop.scss';

const { Title } = Typography;

export const ViewSendouts = () => {
  const {
    emptySendoutIdHandler,
    titleHandler,
    getTimezonesHandler,
    attachmentsHandler,
    navigateToReceiversRegistry,
    scheduleBlock,
    infoBlock,
    isMobile,
    downloadFile,
    getClientFileHandler,
    timezones,
    Sendout,
    Timezone,
    Message,
    Attachments,
    isAccessToReceiversRegistry,
  } = useViewSendout();

  useViewSendoutsEffects({
    emptySendoutIdHandler,
    titleHandler,
    getTimezonesHandler,
    attachmentsHandler,
  });

  return (
    <div className={`${PREFIX}view-sendouts`}>
      <Flex gap={20} vertical={isMobile}>
        <div className="info-block">
          {infoBlock.map(
            ({ label, value, labelDataTestId, valueDataTestId }, index) => (
              <Row gutter={[16, 16]} key={index}>
                <Col span={12}>
                  <strong data-testid={labelDataTestId}>{label}</strong>
                </Col>
                <Col span={12}>
                  <span data-testid={valueDataTestId}>{value}</span>
                </Col>
              </Row>
            )
          )}
          {isAccessToReceiversRegistry && (
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <Button
                  disabled={!Sendout}
                  type="primary"
                  onClick={navigateToReceiversRegistry}
                  data-testid="view-recipients"
                >
                  Смотреть получателей
                </Button>
              </Col>
            </Row>
          )}
        </div>
        <div className="files-block">
          <Title level={5} className="title" data-testid="schedule-title">
            График рассылки
          </Title>
          {scheduleBlock.map(
            ({ label, value, labelDataTestId, valueDataTestId }) => (
              <Row
                gutter={[16, 16]}
                key={label}
                data-testid="sendout-schedule-date-time"
              >
                <Col span={12}>
                  <strong data-testid={labelDataTestId}>{label}</strong>
                </Col>
                <Col span={12}>
                  <span data-testid={valueDataTestId}>{value}</span>
                </Col>
              </Row>
            )
          )}
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <strong data-testid="timezone-title">Часовой пояс</strong>
            </Col>
            <Col span={12}>
              <span data-testid="timezone-value">
                {timezones.find((item) => item.Id === Timezone)?.Name ?? '-'}
              </span>
            </Col>
          </Row>

          <Title level={5} data-testid="content-title">
            Содержание рассылки
          </Title>
          <Card data-testid="sendout-content">{Message}</Card>
          {Attachments ? (
            <div className="action-item">
              <ImageGallery
                files={Attachments}
                getClientFile={getClientFileHandler}
                downloadFile={downloadFile}
              />
            </div>
          ) : null}
          {Attachments?.filter(
            (file) => file.Extension && textExtensions.includes(file.Extension)
          ).map((file) => (
            <TextFileComponent
              getFileImage={getFileImage}
              file={file}
              action={[] as unknown as NActionsHistory.ModelActionHistory}
              downloadFile={downloadFile}
              key={file.Id}
            />
          ))}
        </div>
      </Flex>
    </div>
  );
};
